import { useEffect, useRef, useCallback } from "react";
import { toast } from "react-toastify";
import { env } from "../environment";

const SessionExpiration = ({ children }) => {
  const timeoutDuration = 30 * 60 * 1000; // 30 minutes
  const timeoutRef = useRef();

  const handleLogoutSession = useCallback(async () => {
    try {
      const token = localStorage.getItem("token"); // Retrieve token
      await fetch(`${env.baseURL}/app-users/logout`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // Include auth token
        },
      });
      toast.success("Logout successful!");
    } catch (error) {
      toast.success("Logout successful!");
    }

    // Clear local storage and redirect
    localStorage.clear();
    window.location.href = "/sign-in";
  }, []);

  const resetTimeout = useCallback(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(handleLogoutSession, timeoutDuration);
  }, [handleLogoutSession, timeoutDuration]);

  useEffect(() => {
    // Set up event listeners for user activity
    window.addEventListener("mousemove", resetTimeout);
    window.addEventListener("keypress", resetTimeout);
    window.addEventListener("scroll", resetTimeout);
    window.addEventListener("click", resetTimeout);

    // Initialize the timeout when component mounts
    resetTimeout();

    return () => {
      // Clear timeout and remove event listeners on unmount
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      window.removeEventListener("mousemove", resetTimeout);
      window.removeEventListener("keypress", resetTimeout);
      window.removeEventListener("scroll", resetTimeout);
      window.removeEventListener("click", resetTimeout);
    };
  }, [resetTimeout]);

  return children;
};

export default SessionExpiration;
